import { Box, Divider, Grid, Icon, TextField, Tooltip, Typography } from "@mui/material";
import { CustomButton } from "components/roundedbutton/CustomButton";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import HeaderOuBannerDependendoDaInterpretacaoH1, { headerOuBannerDependendoDaInterpretacaoH1defaultFontSize } from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import { CustomSwitch } from "pages/cadastro-pessoa/CadastroPessoa";
import CustomPoliticaVenda from "pages/Venda/CustomPoliticaVenda";
import { useCallback, useEffect, useRef, useState } from "react";
import { setConfiguracaoPoliticaVenda } from "redux/features/configuracoes";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { theme } from "theme";
import ConfiguracaoDescontoAcrescimoService from "../configuracao-desconto-acrescimo.service";
import { ConfiguracoesChildrenProps } from "../Configuracoes";
import { ConfiguracoesTitle } from "../Configuracoes.model";
import { FlowConfiguracaoPoliticaVendaDTO } from "./politica-venda.model";

const initialState = {
    obrigaNsu: false as boolean,
    obrigaNumeroControle: false as boolean,
    observacaoFixa: '' as string,
    alertaContaReceberVencida: false as boolean,
    alertaConsignadoEmAndamento: false as boolean,
    bloqueiaVendaContaReceberVencida: false as boolean,
    bloqueiaVendaConsignadoEmAndamento: false as boolean,
    imprimirCupomTroca: false as boolean,
    imprimirRomaneio: true as boolean
};

const ConfigurarPoliticaVenda = (props: ConfiguracoesChildrenProps) => {
    const configuracaoService = ConfiguracaoDescontoAcrescimoService();
    const dispatch = useAppDispatch();
    const [stateLocal, setStateLocal] = useState(initialState);
    const { addError, addSuccess } = useSnackbarCustom();
    const isFirstRenderRef = useRef<boolean>(true);
    const estabelecimentoSelecionado = useAppSelector(e => e.estabelecimentoSelecionado);

    const onChangeNSU = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, obrigaNsu: !prevState.obrigaNsu }));
    }, []);

    const onChangeNumeroControle = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, obrigaNumeroControle: !prevState.obrigaNumeroControle }));
    }, []);

    const onChangeAlertaContaReceberVencida = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, alertaContaReceberVencida: !prevState.alertaContaReceberVencida }));
    }, []);

    const onChangeAlertaConsignadoEmAndamento = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, alertaConsignadoEmAndamento: !prevState.alertaConsignadoEmAndamento }));
    }, []);

    const onChangeBloqueiaVendaContaReceberVencida = useCallback(() => {
        setStateLocal(prevState => {
            const bloqueiaVendaContaReceberVencida = !prevState.bloqueiaVendaContaReceberVencida;
            return {
                ...prevState,
                bloqueiaVendaContaReceberVencida,
                alertaContaReceberVencida: bloqueiaVendaContaReceberVencida || prevState.alertaContaReceberVencida
            };
        });
    }, []);

    const onChangeBloqueiaVendaConsignadoEmAndamento = useCallback(() => {
        setStateLocal(prevState => {
            const bloqueiaVendaConsignadoEmAndamento = !prevState.bloqueiaVendaConsignadoEmAndamento;
            return {
                ...prevState,
                bloqueiaVendaConsignadoEmAndamento,
                alertaConsignadoEmAndamento: bloqueiaVendaConsignadoEmAndamento || prevState.alertaConsignadoEmAndamento
            };
        });
    }, []);

    const onChangeImprimirCupomTroca = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, imprimirCupomTroca: !prevState.imprimirCupomTroca }));
    }, []);

    const onChangeImprimirRomaneio = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, imprimirRomaneio: !prevState.imprimirRomaneio }));
    }, []);

    const onChangeObservacaoFixa = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setStateLocal(prevState => ({
            ...prevState,
            observacaoFixa: e.target.value
        }));
    }
        , []);

    const getConfiguracaoPoliticaVenda = useCallback(async () => {
        try {
            const { data: FlowConfiguracaoPoliticaVendaDTO } = await configuracaoService.getConfiguracaoPoliticaVenda();
            if (FlowConfiguracaoPoliticaVendaDTO) {
                setStateLocal(prevState => ({
                    ...prevState,
                    obrigaNsu: FlowConfiguracaoPoliticaVendaDTO.obrigaNsu,
                    obrigaNumeroControle: FlowConfiguracaoPoliticaVendaDTO.obrigaNumeroControle,
                    observacaoFixa: FlowConfiguracaoPoliticaVendaDTO.observacaoFixa ?? '',
                    alertaContaReceberVencida: FlowConfiguracaoPoliticaVendaDTO.alertaContaReceberVencida,
                    alertaConsignadoEmAndamento: FlowConfiguracaoPoliticaVendaDTO.alertaConsignadoEmAndamento,
                    bloqueiaVendaContaReceberVencida: FlowConfiguracaoPoliticaVendaDTO.bloqueiaVendaContaReceberVencida,
                    bloqueiaVendaConsignadoEmAndamento: FlowConfiguracaoPoliticaVendaDTO.bloqueiaVendaConsignadoEmAndamento,
                    imprimirCupomTroca: FlowConfiguracaoPoliticaVendaDTO.imprimirCupomTroca,
                    imprimirRomaneio: FlowConfiguracaoPoliticaVendaDTO.imprimirRomaneio
                }));
            }
        } catch (err) {
            addError({ message: "Não foi possível carregar suas configurações de política de venda", closeable: true });
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado.uuid]);

    const updateConfiguracaoPoliticaVenda = useCallback(async (toSave: FlowConfiguracaoPoliticaVendaDTO) => {
        try {
            const { data } = await configuracaoService.updateConfiguracaoPoliticaVenda(toSave);
            if (data) {
                dispatch(setConfiguracaoPoliticaVenda(data));
                addSuccess({ message: 'configuração política de venda atualizada com sucesso.', closeable: false });
                props.onGoBack();
            }
        } catch (err) {
            addError({ message: "Não foi possivel atualizar suas configuracoes de política de venda", closeable: true });
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!isFirstRenderRef.current) getConfiguracaoPoliticaVenda();
        isFirstRenderRef.current = false;
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        getConfiguracaoPoliticaVenda();
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado]);

    return (
        <>
            <HeaderOuBannerDependendoDaInterpretacaoH1
                id='configurar_politica_venda_header_or_banner'
                customIcon={
                    <CustomPoliticaVenda
                        id="configurar_politica_venda_icon_header"
                        color={theme.palette.text.primary}
                        fontSize={headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.normal}
                        style={{ marginBottom: '5px' }}
                    />
                }
                label={ConfiguracoesTitle.CONFIGURACAO_POLITICA_VENDA}
            />

            <Grid
                container
                spacing={2}
                alignContent={'flex-start'}
                sx={{
                    height: '85%',
                    position: 'relative'
                }}
            >
                <Grid item xs={12} >
                    <Typography
                        sx={{
                            fontSize: 22,
                            marginBottom: '10px'
                        }}
                    >
                        Configuração obrigatoriedade cartão
                    </Typography>
                    <Divider />
                </Grid>



                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Obrigar informar NSU
                        </Typography>

                        <CustomSwitch
                            id='obriga-informar-nsu'
                            checked={stateLocal.obrigaNsu}
                            onChange={onChangeNSU}
                            inputProps={{ 'aria-label': 'Obrigar informar NSU' }}
                            name="obriga-informar-nsu" />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            marginTop: '20px'
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Obrigar informar número de controle
                        </Typography>

                        <CustomSwitch
                            id='obriga-informar-numero-controle'
                            checked={stateLocal.obrigaNumeroControle}
                            onChange={onChangeNumeroControle}
                            inputProps={{ 'aria-label': 'Obrigar informar número de controle' }}
                            name="obriga-informar-numero-controle" />
                    </Box>

                </Grid>

                <Grid item xs={12} >
                    <Typography
                        sx={{
                            fontSize: 22,
                            marginBottom: '10px'
                        }}
                    >
                        Configuração de alerta
                    </Typography>
                    <Divider />
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Alerta contas a receber vencido
                        </Typography>

                        <CustomSwitch
                            id='alerta-contas-receber-vencido'
                            checked={stateLocal.alertaContaReceberVencida}
                            onChange={onChangeAlertaContaReceberVencida}
                            disabled={stateLocal.bloqueiaVendaContaReceberVencida}
                            inputProps={{ 'aria-label': 'Alerta contas a receber vencido' }}
                            name="alerta-contas-receber-vencido" />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            marginTop: '20px'
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Alerta consignado em andamento
                        </Typography>

                        <CustomSwitch
                            id='alerta-consignado-em-andamento'
                            checked={stateLocal.alertaConsignadoEmAndamento}
                            onChange={onChangeAlertaConsignadoEmAndamento}
                            disabled={stateLocal.bloqueiaVendaConsignadoEmAndamento}
                            inputProps={{ 'aria-label': 'Alerta consignado em andamento' }}
                            name="alerta-consignado-em-andamento" />
                    </Box>

                </Grid>

                <Grid item xs={12} >
                    <Typography
                        sx={{
                            fontSize: 22,
                            marginBottom: '10px'
                        }}
                    >
                        Bloqueio venda
                    </Typography>
                    <Divider />
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Bloquear venda para cliente que possui contas a receber vencido
                        </Typography>

                        <CustomSwitch
                            id='bloqueia-venda-contas-receber-vencido'
                            checked={stateLocal.bloqueiaVendaContaReceberVencida}
                            onChange={onChangeBloqueiaVendaContaReceberVencida}
                            inputProps={{ 'aria-label': 'Bloquear venda para cliente que possui contas a receber vencido' }}
                            name="bloqueia-venda-contas-receber-vencido" />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '20px'
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Bloquear venda para cliente que possui consignado em andamento
                        </Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                            <CustomSwitch
                                id='bloqueia-venda-consignado-em-andamento'
                                checked={stateLocal.bloqueiaVendaConsignadoEmAndamento}
                                onChange={onChangeBloqueiaVendaConsignadoEmAndamento}
                                inputProps={{ 'aria-label': 'Bloquear venda para cliente que possui consignado em andamento' }}
                                name="bloqueia-venda-consignado-em-andamento" />

                            <Box sx={{
                                position: 'absolute',
                                left: 'calc(50% + 30px)',
                                display: 'flex',
                            }}>
                                <Tooltip
                                    arrow
                                    title={
                                        <Typography fontSize={15}>
                                            Sistema bloqueia venda para o cliente que possui consignado com as situações consignado e parcial.
                                        </Typography>
                                    }
                                >
                                    <Icon
                                        className="fa-solid fa-circle-info"
                                        fontSize="small"
                                        sx={{ color: theme.palette.primary.main, padding: '3px' }}
                                    />
                                </Tooltip>
                            </Box>

                        </Box>
                    </Box>

                </Grid>

                <Grid item xs={12} >
                    <Typography
                        sx={{
                            fontSize: 22,
                            marginBottom: '10px'
                        }}
                    >
                        Configuração de impressão
                    </Typography>
                    <Divider />
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Imprimir cupom de troca
                        </Typography>

                        <CustomSwitch
                            id='imprimir-cupom-troca'
                            checked={stateLocal.imprimirCupomTroca}
                            onChange={onChangeImprimirCupomTroca}
                            inputProps={{ 'aria-label': 'Imprimir cupom de troca' }}
                            name="imprimir-cupom-troca" />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            marginTop: '20px'
                        }}>
                        <Typography
                            sx={{
                                fontSize: 18,
                                color: theme.palette.text.primary
                            }}
                        >
                            Imprimir romaneio
                        </Typography>

                        <CustomSwitch
                            id='imprimir-romaneio'
                            checked={stateLocal.imprimirRomaneio}
                            onChange={onChangeImprimirRomaneio}
                            inputProps={{ 'aria-label': 'Imprimir romaneio' }}
                            name="imprimir-romaneio" />
                    </Box>

                </Grid>

                <Grid item xs={12} md={12}>
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                        }}>
                        <TextField
                            multiline
                            fullWidth
                            label="Observação fixa para pedidos de romaneio"
                            maxRows={15}
                            variant="outlined"
                            value={stateLocal.observacaoFixa}
                            onChange={onChangeObservacaoFixa}
                            inputProps={{ maxLength: 3500 }}
                            helperText={`Máximo de 3500 caracteres. ${stateLocal.observacaoFixa.length}/3500`}
                        />
                    </Box>
                </Grid>

                <Grid item
                    sx={{
                        bottom: '15px',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                    }}
                >
                    <CustomButton
                        sx={{ minWidth: '80px' }}
                        id="voltar-configuracao-vale-presente-btn"
                        onClick={props.onGoBack}
                        variant="contained"
                        color="error"
                        startIcon={<Icon className='fa-solid fa-arrow-left' />}>
                        Voltar
                    </CustomButton>

                    <CustomButton
                        sx={{ minWidth: '80px' }}
                        id="voltar-configuracao-vale-presente-btn"
                        onClick={() => updateConfiguracaoPoliticaVenda(stateLocal)}
                        variant="contained"
                        color="success"
                        startIcon={<Icon className='fa-solid fa-check' />}>
                        Salvar
                    </CustomButton>
                </Grid>
            </Grid>
        </>
    );
};

export default ConfigurarPoliticaVenda;
